import { PhotoSpinner } from './PhotoSpinner';

/** Dims the photo and shows how much of a new upload has been sent. */
export function PhotoUploadOverlay({ progress }: { progress: number }) {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(15,25,18,.58)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        color: '#fff',
      }}
    >
      <PhotoSpinner />
      <div style={{ fontSize: 12.5, fontWeight: 700 }}>Uploading… {progress}%</div>
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          height: 4,
          background: 'rgba(255,255,255,.2)',
        }}
      >
        <i
          style={{
            display: 'block',
            height: '100%',
            width: `${progress}%`,
            background: 'var(--nb-leaf)',
          }}
        />
      </div>
    </div>
  );
}
